import { render, staticRenderFns } from "./NoticeboardList.vue?vue&type=template&id=e1222b70&scoped=true&"
import script from "./NoticeboardList.vue?vue&type=script&lang=js&"
export * from "./NoticeboardList.vue?vue&type=script&lang=js&"
import style0 from "./NoticeboardList.vue?vue&type=style&index=0&id=e1222b70&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1222b70",
  null
  
)

export default component.exports
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QList});
